var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-only"},[(_vm.$store.state.user)?[_vm._t("default")]:_c('div',{staticClass:"d-flex justify-content-center auth-only-button"},[_c('AlcorButton',{staticClass:"connect",attrs:{"type":"default"},on:{"click":function($event){return _vm.$store.dispatch("chain/mainLogin")}}},[_vm._v(_vm._s(_vm.$t('Connect Wallet')))])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }